import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import {
  AccessPermissionService,
  dblclickTooltipDef,
  defaultColumn,
  grid_widths_map,
  mainModuleName,
  rolesModuleName,
  subModuleName,
} from '@piqet-angular/shared';
import { AdministratorFacade, getRolesAndPermission } from '@piqet-angular/data';
import { GridIconComponent } from 'libs/ui/src/lib/grid-icon/grid-icon.component';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class OtherEquivalancyUnitsDataGridService {
  otherEquivalancyUnitsDataPayload: any;
  event: any;
  openModal = new Subject<any>();
  openModalObservable$ = this.openModal.asObservable();
  constructor(
    private AdministratorFacade: AdministratorFacade,
    private accessService: AccessPermissionService
  ) {}

  getOtherEquivalancyUnitsDataColumn(pathName?: string): ColDef[] {
    const colDef: ColDef[] = [];

    colDef.push({
      ...defaultColumn,
      colId: 'OrganizationName',
      headerName: 'Name',
      field: 'organizationName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      editable: false,
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.style.cursor = 'pointer';
        cellElement.innerHTML = `${cellValue}`;
        cellElement.title = dblclickTooltipDef;
        const checkAccess =
          this.isAccess(pathName, 'edit') ||
          this.isAccess(pathName, 'create') ||
          this.isAccess(pathName, 'view');
        if (checkAccess) {
          cellElement.style.textDecoration = 'underline';
        }
        cellElement.addEventListener('dblclick', () => {
          checkAccess && this.openModal.next('');
        });
        return cellElement;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Name',
      headerName: 'Impact categories',
      field: 'name',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      editable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'EquivalencyUnits',
      headerName: 'Equivalency units',
      field: 'equivalencyUnits',
      minWidth: grid_widths_map.lg_column_sm,
      cellClass: 'my-permission-cursor-pointer',
      cellStyle: { color: 'red' },
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      filter: 'agTextColumnFilter',
      resizable: false,
      editable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'EquivalencyImage',
      headerName: 'Equivalency image',
      field: 'equivalencyImage',
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'GridEquivalancyImageComponent',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      editable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Multiplier',
      headerName: 'Multiplier',
      field: 'multiplier',
      cellStyle: { color: 'red' },
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      filter: 'agTextColumnFilter',
      resizable: false,
      editable: false,
    });

    return colDef;
  }

  isAccess = (pathName: any, type: 'view' | 'edit' | 'create' | 'delete') => {
    return pathName == 'OrganizationEquivalancyUnits'
      ? this.accessService.hasModulePermission(
          rolesModuleName.DataManageOtherDataEquivalencyUnits,
          subModuleName.otherDataModule,
          type
        )
      : this.accessService.hasModulePermission(
          rolesModuleName.DataManageOtherDataEquivalencyUnits,
          mainModuleName.myOrganizationModule,
          type
        );
  };

  getPayload(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.getOtherEquivalancyUnitsDataColumn()
      .map((item: any) => {
        return {
          searchable: item.colId == 'EquivalencyImage' ? false : true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'Actions');

    return (this.otherEquivalancyUnitsDataPayload = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'organizationName',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Desc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }
}
